import { buscarReservaPeriodo } from "../../../services/buscarReservaPeriodoService";
import { buscarReservaSemPeriodo } from "../../../services/buscarReservaSemPeriodoService";
import { cadastrarReserva } from "../../../services/cadastrarReserva";

/**
 * Hook responsável por verificar se existe uma reserva vinculada a um período de usuário.
 * Caso não exista, tenta buscar uma reserva disponível ou criar uma nova.
 */
export const useReservadoMC = () => {
  /**
   * Verifica se há uma reserva associada ao período do usuário e
   * redireciona para a tela de gerenciamento de reservas.
   */
  const verificarReserva = async (periodoUsuarioId: number) => {
    // 1. Busca uma reserva já vinculada ao período do usuário
    const buscarReserva = await buscarReservaPeriodo(periodoUsuarioId);

    if (buscarReserva) {
      // Se encontrar, redireciona para o gerenciamento de reservas
      window.location.href = `/gerenciarReserva?periodoUsuarioId=${periodoUsuarioId}`;
      return;
    }

    // 2. Se não encontrar, verifica se há reservas sem período vinculado
    const existReservaSemPeriodo = await buscarReservaSemPeriodo();

    if (existReservaSemPeriodo) {
      // Se houver, redireciona para o operador vincular manualmente
      window.location.href = `/gerenciarReserva?periodoUsuarioId=${periodoUsuarioId}`;
      return;
    }

    // 3. Se não houver, cria uma nova reserva vinculada ao período
    const reservaData = {
      dataReserva: new Date(),
      periodoUsuarioId,
    };

    try {
      const cadastrar = await cadastrarReserva(reservaData);
      if (cadastrar) {
        // Redireciona após criar a nova reserva
        window.location.href = `/gerenciarReserva?periodoUsuarioId=${periodoUsuarioId}`;
      }
    } catch (error) {
      // Log de erro ao tentar cadastrar reserva
      console.error("Erro ao cadastrar reserva:", error);
    }
  };

  return { verificarReserva };
};
